/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Local logic module reducers
 */

import { SerializableMap } from '@zcode/bizos'
import { payloadReducer } from '@zcode/reducers'
import type { LocalLogic } from '@zcode/state-type'
import { filterActions } from '@zumper/redux-ignore'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import {
  LOADED_POI_FOR,
  LOADING_POI,
  RECEIVE_LOCATION_POIS,
  RECEIVE_LOCATION_SCORES,
  SET_POI_LOCATION,
} from '../constants'
import type { ActionTypes } from '../types/index'
import { allowedList } from './allowedList'

const rootReducer = combineReducers<LocalLogic, ActionTypes>({
  loadingPoi: handleAction<LocalLogic['loadingPoi'], ActionTypes, typeof LOADING_POI>(
    LOADING_POI,
    payloadReducer,
    false
  ),
  loadedPoiFor: handleAction<LocalLogic['loadedPoiFor'], ActionTypes, typeof LOADED_POI_FOR>(
    LOADED_POI_FOR,
    payloadReducer,
    null
  ),
  locationScores: handleAction<
    LocalLogic['locationScores'],
    ActionTypes,
    typeof RECEIVE_LOCATION_SCORES
  >(RECEIVE_LOCATION_SCORES, payloadReducer, {}),
  locationPois: handleAction<LocalLogic['locationPois'], ActionTypes, typeof RECEIVE_LOCATION_POIS>(
    RECEIVE_LOCATION_POIS,
    payloadReducer,
    new SerializableMap()
  ),
  selectedPoi: handleAction<LocalLogic['selectedPoi'], ActionTypes, typeof SET_POI_LOCATION>(
    SET_POI_LOCATION,
    payloadReducer,
    {}
  ),
})
export const localLogicReducer = filterActions(rootReducer, allowedList)
